export default function Buton({ type, icon, ...props }) {
    return (
        <button {...props}>{type}
            <i className="material-icons right">{icon}</i>
        </button>
    )
}